import { ReactElement } from "react"
import { LinkProps } from "./link-props"
import * as S from './link-style'

export function LinkEmpty (props: LinkProps): ReactElement {
  return <S.LinkEmpty {...props} />
}